import { useQuery } from "@tanstack/react-query";

import { feedbackQuestionsKeys } from "../../../../redux/services/feedbackInclusiveEducationPartOne";

import { getFeedbackQuestionsListApiCall } from "./utils.api";

export const useGetFeedbackQuestionTypeKeys = (payload) =>{
    const {languageId , course}= payload;

    return useQuery({
        queryKey: feedbackQuestionsKeys.getFeedBackQuestions(),
        queryFn: () => getFeedbackQuestionsListApiCall({languageId , course }),
    });
}